var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPersoneIc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.32
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.9987 7.3335C34.392 7.3335 26.582 15.1435 26.582 24.7502C26.582 34.1735 33.952 41.8002 43.5587 42.1302C43.852 42.0935 44.1454 42.0935 44.3654 42.1302C44.4387 42.1302 44.4754 42.1302 44.5487 42.1302C44.5854 42.1302 44.5854 42.1302 44.622 42.1302C54.0087 41.8002 61.3787 34.1735 61.4154 24.7502C61.4154 15.1435 53.6054 7.3335 43.9987 7.3335Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.6275 51.8836C52.3975 45.0636 35.7142 45.0636 25.4108 51.8836C20.7542 55.0002 18.1875 59.2169 18.1875 63.7269C18.1875 68.2369 20.7542 72.4169 25.3742 75.4969C30.5075 78.9436 37.2542 80.6669 44.0008 80.6669C50.7475 80.6669 57.4942 78.9436 62.6275 75.4969C67.2475 72.3802 69.8142 68.2002 69.8142 63.6536C69.7775 59.1436 67.2475 54.9636 62.6275 51.8836Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersoneIc);
export default __webpack_public_path__ + "static/media/persone_ic.bad53d59bcc19d95e0bd6062f7298b78.svg";
export { ForwardRef as ReactComponent };